import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ContactList from "./ContactList";
import type MediaRelease from "./MediaRelease";

@Model()
class MediaReleasesContactList extends ApplicationRecord {
  static jsonapiType = "media_releases_contact_lists";

  @BelongsTo() contactList: ContactList;

  @Attr() contactListId: number;

  @BelongsTo() mediaRelease: MediaRelease;

  @Attr() mediaReleaseId: number;
}

export default MediaReleasesContactList;
